import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';

/** Any address that isn't a page of the site. Kept out of Google (noindex); Hosting answers 404. */
export default function NotFoundPage() {
  const { t } = useTranslation();
  usePageTitle(t('seo.notFound'), { noindex: true });

  return (
    <div className="max-w-3xl mx-auto px-4 py-16 text-center space-y-4">
      <h1 className="text-xl font-semibold text-ink">{t('seo.notFound')}</h1>
      <p className="text-ink">{t('seo.notFoundText')}</p>
      <Link to="/" className="text-sm text-ink underline">
        {t('seo.goHome')}
      </Link>
    </div>
  );
}
